import { render, staticRenderFns } from "./SwitchPlus.vue?vue&type=template&id=029adfb3&scoped=true&"
import script from "./SwitchPlus.vue?vue&type=script&lang=js&"
export * from "./SwitchPlus.vue?vue&type=script&lang=js&"
import style0 from "./SwitchPlus.vue?vue&type=style&index=0&id=029adfb3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029adfb3",
  null
  
)

export default component.exports